import {invert} from 'lodash';

import {RouletteStatusVo} from '../../common/shared/api/nicolas/vo/enums/RouletteStatusVo.enum';
import {RouletteStatus} from '../generated/types';

const STATUS_MAP: Record<RouletteStatusVo, RouletteStatus> = {
  [RouletteStatusVo.Already]: RouletteStatus.Already,
  [RouletteStatusVo.Disable]: RouletteStatus.Disable,
  [RouletteStatusVo.Duplicate]: RouletteStatus.Duplicate,
  [RouletteStatusVo.BudgetCrunch]: RouletteStatus.BudgetCrunch,
  [RouletteStatusVo.Error]: RouletteStatus.Error,
  [RouletteStatusVo.Expire]: RouletteStatus.Expire,
  [RouletteStatusVo.Fail]: RouletteStatus.Fail,
  [RouletteStatusVo.First]: RouletteStatus.First,
  [RouletteStatusVo.Noauth]: RouletteStatus.Noauth,
  [RouletteStatusVo.TicketFail]: RouletteStatus.TicketFail,
  [RouletteStatusVo.WaitRedeemResult]: RouletteStatus.WaitRedeemResult,
  [RouletteStatusVo.Draw]: RouletteStatus.Draw,
  [RouletteStatusVo.Success]: RouletteStatus.Success,
  [RouletteStatusVo.UnknownApiStatus]: RouletteStatus.UnknownApiStatus,
};

const REVERSE_STATUS_MAP = invert(STATUS_MAP) as Record<
  RouletteStatus,
  RouletteStatusVo
>;

export function createRouletteStatus(status = RouletteStatusVo.Success) {
  return STATUS_MAP[status] || RouletteStatus.Unknown;
}

export function convertRouletteStatusToVo(
  status: RouletteStatus
): RouletteStatusVo {
  return REVERSE_STATUS_MAP[status] || RouletteStatusVo.Error;
}
